const styles = () => ({
  notification: {
    borderRadius: 10,
    padding: '10px 20px',
    margin: '30px 40px 20px 40px',
    boxSizing: 'border-box',
    background: '#FAF7EE',
    border: '1px solid #FDE08E',
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
  },

  notificationLogo: {
    alignSelf: 'center',
    marginRight: 20,
  },

  notificationTitle: {
    fontWeight: 500,
    fontSize: 16,
    color: '#976000',
  },

  notificationInfo: {
    flex: 1,
    flexGrow: 1,
    minWidth: 130,
  },

  notificationDetails: {
    flex: 5,
  },

  notificationMessage: {
    color: '#976000',
  },

  notificationActions: {
    marginLeft: 10,
    display: 'flex',
    alignItems: 'center',
  },

  lastUpdated: {
    color: '#976000',
    marginRight: 12,
  },

  notificationResolvebutton: {
    fontSize: 14,
    background: 'linear-gradient(#FDCC50, #FCA000)',
    color: 'white',
    borderRadius: 6,
    minHeight: '32px',
    padding: '2px 16px',
    border: '1px solid rgba(0, 0, 0, 0.05)',
    textTransform: 'none',
    letterSpacing: 0,
  },
});

export default styles;
